export const checkPassword = (value: any) => {
  const expression = /(?=.*[0-9])(?=.*[a-z])[0-9a-zA-Z!@#$%^&*]{8,}/g;
  return expression.test(value);
};
